import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "antd";
import { useMemo } from "react";
import { useFormContentBlocker, useFormService, useI18n } from "../../contexts";
import { Notices } from "../common";
import { FormServiceLayout } from "./service";
const FormUntranslatedTemplateNotice = (param)=>{
    let { form } = param;
    const { _n } = useI18n();
    const { template } = form === "service" ? useFormService() : useFormContentBlocker();
    const { items, hasNames } = useMemo(()=>{
        var _template_consumerData;
        const items = Object.values((template == null ? void 0 : (_template_consumerData = template.consumerData) == null ? void 0 : _template_consumerData.translations) || {}).filter((param)=>{
            let { isUntranslated } = param;
            return isUntranslated;
        });
        return {
            items,
            hasNames: items.filter((param)=>{
                let { name } = param;
                return name;
            }).length > 0
        };
    }, [
        template
    ]);
    return items.length > 0 ? /*#__PURE__*/ _jsx(Form.Item, {
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span,
            span: FormServiceLayout.wrapperCol.span
        },
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ _jsx(Notices, {
            notices: [
                {
                    severity: "info",
                    message: _n("This template is not yet translated into your language%s. You can still use it without any issues, but you have to translate it yourself.", "This template is not yet translated into your languages%s. You can still use it without any issues, but you have to translate it yourself.", hasNames ? 2 : 1, // Multilingual plugin like WPML in use, we can list the untranslated languages
                    hasNames ? ` (${items.map((param)=>{
                        let { name } = param;
                        return name;
                    }).join(", ")})` : "")
                }
            ]
        })
    }) : null;
};
export { FormUntranslatedTemplateNotice };
